(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsible-content-balance"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.collapsible-content__button').forEach(button => {
  button.addEventListener('click', () => {
    const parent = button.closest('.collapsible-content__item');
    const isOpen = parent.classList.contains('is-open');

    // Close all
    document.querySelectorAll('.collapsible-content__item').forEach(item => item.classList.remove('is-open'));

    // Toggle current
    if (!isOpen) parent.classList.add('is-open');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
